export default function Section2() {
  return (
    <div className="Section2">
      <div className="section2-container">
        <div className="md:w-[80%] my-[24px] mx-5 md:my-0 md:mx-auto text-center">
          <h1 className="text-[24px] md:text-[34px] font-bold leading-[32px] md:leading-[41px] text-[#151515] mt-[40px]">
           Texas Performance Marketing Company Driving Measurable Results
          </h1>

          <p className="pt-[1%] leading-[20px] text-[16px] font-open text-[#535353]">
            Are your paid ads failing to deliver the results you expected? Many businesses invest in advertising but struggle to turn that spend into consistent results. The difference isn’t just running ads — it’s having the right strategy behind them. As a performance marketing firm, we’ve helped brands turn underperforming campaigns into scalable growth engines through data-driven strategies, continuous optimization, and a clear focus on ROI, conversions, and measurable business impact.
          </p>
        </div>

        <div className="flex flex-col md:flex-row px-5 md:px-[30px] mb-[4%] md:my-0 md:mt-[68px] md:items-center md:justify-evenly">
          <div className="md:w-[36%]">
            <h2 className="md:text-[34px] font-bold my-[0.67em] text-[24px] leading-[32px] md:leading-[41px] text-[#DA2128] pb-[2%]">
                Performance Marketing Solutions for Texas Businesses
            </h2>

            <p className="pb-[1%] mb-5 leading-[20px] text-[16px] font-open text-[#373737]">
            In today’s competitive market, effective marketing requires more than just impressions. As one of the leading advertising marketing agencies in Texas, we design strategies that reach the right audience, drive engagement, and increase conversions.
            </p>
            <p className="pb-[1%] mb-5 leading-[20px] text-[16px] font-open text-[#373737]">
             We specialize in solutions for:
            </p>
            <ul className="list-disc text-[#373737]">
              <li className="mt-2">E-commerce performance marketing to increase online sales and improve customer acquisition</li>
              <li className="mt-2">Service-based businesses seeking qualified leads across Texas</li>
              <li className="mt-2">Campaigns optimized to maximize efficiency, growth, and revenue</li>
            </ul>
            <p className="pb-[1%] my-5 leading-[20px] text-[16px] font-open text-[#373737]">Every strategy we build focuses on results rather than guesswork, ensuring measurable outcomes for your business.</p>
          </div>

          <div className="w-full image-cont md:w-auto">
            <img className="w-full md:w-auto" src="../../../../assets/artboard-performance-marketing.png"></img>
          </div>
        </div>

        <div className="line my-[55px] md:my-[4%] mx-auto w-[70%] md:w-[61%] shadow-line h-2 rounded-[100%]"></div>
      </div>
    </div>
  );
}
